// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"106":"051bbfcb","182":"d4956b88","388":"3fcc9737","453":"e5864126","559":"e11a2231","700":"de15fd7d","753":"c7eb2c1a","855":"b60b5014","858":"31d1ecb4"}[chunkId] + ".chunk.js";
};